import { Link } from "react-router-dom";
import styled from "styled-components";
import { cPath } from "../../constants";

const Card = styled.div`
  background: hsl(${({ theme }) => theme.colors.card});
  border-radius: ${({ theme }) => theme.radius.lg};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  padding: 1.25rem;
  margin-bottom: 1.5rem;
`;

const H3 = styled.h3`
  margin: 0 0 1rem;
  font-weight: 700;
  font-size: 1rem;
  color: hsl(${({ theme }) => theme.colors.foreground});
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.875rem;
  margin-bottom: 0.75rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

const Muted = styled.span`
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
`;

const Maroon = styled.span`
  font-weight: 600;
  color: hsl(${({ theme }) => theme.colors.couponMaroon});
`;

const Bold = styled.span`
  font-weight: 600;
  color: hsl(${({ theme }) => theme.colors.foreground});
`;

const Accent = styled.span`
  font-weight: 600;
  color: hsl(${({ theme }) => theme.colors.accent});
`;

const About = styled.div`
  font-size: 0.875rem;
  line-height: 1.6;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
`;

const SimilarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
`;

const Sim = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem;
  border-radius: ${({ theme }) => theme.radius.lg};
  &:hover {
    background: hsl(${({ theme }) => theme.colors.muted});
  }
`;

const SimImg = styled.img`
  width: 2rem;
  height: 2rem;
  border-radius: 0.25rem;
  object-fit: contain;
`;

const SimName = styled.span`
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
  color: hsl(${({ theme }) => theme.colors.foreground});
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export default function StoreSideColumn({
  store,
  highlights,
  relatedStores,
  localized,
}) {
  const aboutHtml = localized?.description;

  return (
    <div>
      {aboutHtml && (
        <Card>
          <H3>About {localized?.name || store.name}</H3>
          <About dangerouslySetInnerHTML={{ __html: aboutHtml }} />
        </Card>
      )}
      <Card>
        <H3>Coupon Highlights</H3>
        <Row>
          <Muted>Best Discount:</Muted>
          <Maroon>{highlights.bestDiscount}</Maroon>
        </Row>
        <Row>
          <Muted>Coupon Codes:</Muted>
          <Bold>{highlights.couponCodes}</Bold>
        </Row>
        <Row>
          <Muted>Total Offers:</Muted>
          <Bold>{highlights.totalOffers}</Bold>
        </Row>
        <Row>
          <Muted>Avg. Savings:</Muted>
          <Accent>{highlights.avgSavings}</Accent>
        </Row>
      </Card>
      {relatedStores.length > 0 && (
        <Card>
          <H3>Similar Stores</H3>
          <SimilarGrid>
            {relatedStores.map((s) => (
              <Sim key={s.id} to={cPath(`store/${s.slug}`)}>
                <SimImg src={s.logo} alt={s.name} />
                <SimName>{s.name}</SimName>
              </Sim>
            ))}
          </SimilarGrid>
        </Card>
      )}
    </div>
  );
}
